import React, { Component } from 'react';
import { Button, Row, Popconfirm, Col, Icon, Spin, Radio, Form, Select, Input , Modal} from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LayoutHeader from '../Inc/Header';
import AlumniNavigation from '../Inc/AlumniNavigation';
import { compose } from 'recompose';
import { DeleteOutlined } from '@ant-design/icons';

import './layout.css';

import MyAwardsComponent from "./AwardSections";
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const FormItem = Form.Item;
class ManageMemberID extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount = () => {
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        localStorage.setItem("panelView", JSON.stringify("alumniTabView"))
        let personGUID = loggedinUser.personGuid;
        this.props.actions.getmemberid(personGUID, true, null, true, true)
        // this.props.actions.getmemberid(null, true, null, true, true)
        this.props.actions.getAllOrganizationCouncils()

        // this.props.actions.getEagleInfo()
        // this.props.actions.getProfileInfo(personGUID)

        // Define a reusable function to check and dispatch if the array is empty
        const checkAndDispatch = (array, action) => {
            if (!Array.isArray(array) || (Array.isArray(array) && array.length === 0)) {
                action();
            }
        };
        // Usage
        checkAndDispatch(this.props.scoutings, this.props.actions.getallscoutingassociations);
        checkAndDispatch(this.props.councils, this.props.actions.getallcouncils);
        checkAndDispatch(this.props.affinities, this.props.actions.getAllAffinityGroups);
        checkAndDispatch(this.props.localAwards, this.props.actions.getAllLocalAwards);
  
    }

    renderMemberid = () => {
        if (this.props.memberids) {
            const spanWidth = this.props.memberids.length > 2 ? 8 : 12;
            let self = this
            return this.props.memberids.map(function (memberid, i) {
                if (memberid.isPrimary == true) return false
                return <Col xs={24} sm={24} md={spanWidth} lg={spanWidth} xl={spanWidth} className='padding-15'>
                    <div className='container Full-height box-shadow' style={{margin: '0px'}}>
                        <div className='widget-content widget-content-align'>
                            <Row type="flex" justify="start" align="middle" style={{height : '100%'}}>
                                <Row style={{width: '100%'}}>
                                    <Col span={17}>
                                        <Col span={24}><span className='member-card-header'>Member ID</span></Col>
                                        <Col span={24}><span className='member-card-data'>{memberid.memberId}</span></Col>
                                    </Col>

                                    {memberid.isEagle &&
                                        <Col span={7} style={{textAlign : 'center'}}>
                                            <img className='member-eagle-logo' src='../eagle-scout.png'></img>
                                        </Col>
                                    } 
                                </Row>
                                <Col span={24} className='m-t-10'>
                                    <Col span={24}><span className='member-card-header'>Council Name</span></Col>
                                    <Col span={24}><span className='member-card-data'>{memberid.councilName}</span></Col>
                                </Col>


                                {/* <Col span={24} className='m-t-10'>
                                    <Col span={24}><span className='member-card-header'>My Awards</span></Col>
                                </Col>
                                {memberid.awards && memberid.awards.awards.length > 0 ? memberid.awards.awards.map(award => (
                                    <Col span={24} className='m-t-5' style={{ display: 'flex', alignItems: 'center' }} >
                                        <Col span={4}>
                                            <img className='member-awards-logo' src={award.imageFilePath}></img>
                                        </Col>
                                        <Col span={20}><span className='member-card-data'>{award.name}</span></Col>
                                    </Col>
                                )) :
                                    <Col span={24} className='m-t-5' style={{ display: 'flex', alignItems: 'center' }} >
                                        <Col span={4}>
                                            <img className='member-awards-logo' src='../noawards.png'></img>
                                        </Col>
                                        <Col span={20}><span className='member-card-data'> No awards associated with this Member ID!</span></Col>
                                    </Col>
                                } */}



                                <div style={{display: 'flex', flexDirection: 'column', flex: '1'}}>
                                    <hr className="line-divider-full margin-16" />
                                    <Row type="flex" align='middle' >
                                        <Col span={15}> <Radio key={memberid.memberId} value={memberid.memberId} onChange={() => self.props.actions.setPrimaryMemberid('update', memberid.memberId)} className='default-txt'>SET AS PRIMARY</Radio> </Col>
                                        <Col span={9} style={{textAlign: 'end'}}>
                                            <Popconfirm placement="top" title="Are you sure to delete this?" onConfirm={() => self.props.actions.setPrimaryMemberid('delete', memberid.memberId)} okText="Yes" cancelText="No">
                                                <Button type="text" className='default-txt border-0' style={{fontSize: '14px'}}> <DeleteOutlined /> REMOVE</Button>
                                            </Popconfirm>
                                        </Col>
                                    </Row>
                                </div>

                            </Row>
                        </div>
                    </div>
                </Col>
            })
        }
    }

    renderPrimaryMemberid = () => {
        if (this.props.memberids) {
            const spanWidth = this.props.memberids.length > 2 ? 8 : 12;
            let primaryMemberid = this.props.memberids.filter((memberid) => memberid.isPrimary == true)[0]
            return <Col xs={24} sm={24} md={spanWidth} lg={spanWidth} xl={spanWidth} className='padding-15'>
                <div className='container  primary-border Full-height box-shadow' style={{margin: '0px'}}>
                    <div className='widget-content widget-content-align'>
                        {/* <Row type="flex" justify="start" align="middle"> */}
                        <Row>
                            <Col span={17}>
                                <Col span={24}><span className='member-card-header'>Member ID</span></Col>
                                <Col span={24}><span className='member-card-data'>{primaryMemberid.memberId}</span></Col>
                            </Col>
                            {primaryMemberid.isEagle &&
                                <Col span={7} style={{textAlign : 'center'}}>
                                    <img className='member-eagle-logo' src='../eagle-scout.png'></img>
                                </Col>
                            } 
                        </Row>
                        <Col span={24} className='m-t-10'>
                                    <Col span={24}><span className='member-card-header'>Council Name</span></Col>
                                    <Col span={24}><span className='member-card-data'>{primaryMemberid.councilName}</span></Col>
                                </Col>

                        {/* <Col span={24} className='m-t-10'>
                                    <Col span={24}><span className='member-card-header'>My Awards</span></Col>
                                </Col>
                                {primaryMemberid.awards && primaryMemberid.awards.awards.length > 0 ? primaryMemberid.awards.awards.map(award => {
                                   return <Col span={24} className='m-t-5' style={{ display: 'flex', alignItems: 'center' }} >
                                        <Col span={4}>
                                            <img className='member-awards-logo' src={award.imageFilePath}></img>
                                        </Col>
                                        <Col span={20}><span className='member-card-data'>{award.name}</span></Col>
                                    </Col>
                                }) :
                                    <Col span={24} className='m-t-5' style={{ display: 'flex', alignItems: 'center' }} >
                                        <Col span={4}>
                                            <img className='member-awards-logo' src='../noawards.png'></img>
                                        </Col>
                                        <Col span={20}><span className='member-card-data'> No awards associated with this Member ID!</span></Col>
                                    </Col>
                                } */}

                        <div>
                            <hr className="line-divider-full margin-16" />
                            <Row type="flex" align='middle' justify='space-between'>
                                <Radio className='prime-txt' style={{margin : '5px 0px', fontSize: '14px'}} checked>PRIMARY</Radio>
                            </Row>
                        </div>
                        {/* </Row> */}
                    </div>
                </div>
            </Col>
        }
    }

allCouncils = () => {
        if (this.props.allCouncils) {
            let councilsArray = this.props.allCouncils.sort((a, b) => a.name - b.name)
            return councilsArray.map((k, index) => {
                return (
                    <option key={k.councilGuid} value={k.councilGuid}>{k.councilName}</option>
                )
                // this.forceUpdate()
            })
        }
    }

    handleAddMemberID = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { memberid, councilGuid } = values;
                const getCouncil = this.props.allCouncils.find(council => council.councilGuid === councilGuid); // To get the councilGuid for the council which entered 
                // To check if the entered council and MID are already linked with the username
                if (getCouncil && this.props.memberids.findIndex(memberDetails => memberDetails.memberId.toString() === memberid.toString()) >= 0) {
                    Modal.warning({
                        title: 'Failed!',
                        content: 'This MemberID is already linked with the user name.'
                    });
                } else {
                    this.props.actions.addMemberID(memberid, councilGuid, false);
                    this.props.form.resetFields();
                }
            }
        }
        )
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <LayoutHeader />
                <AlumniNavigation />
                <Row type="flex" justify="center">
                    <Col xs={23} sm={23} md={23} lg={18} xl={18}>
                        <div>
                            <div className='container-header manage-MID-container-header '>
                                <Row type="flex" justify="space-between">
                                    <span className='text'>Manage Member ID</span>
                                </Row>
                            </div>
                            <div className='manageMID-Search'>
                                {/* <Row type="flex" justify="space-between"> */}
                                <Form onSubmit={this.handleAddMemberID} className="search-form alumni-ui">
                                    <Row type="flex" justify='space-between' style={{ alignItems: 'center' }}>
                                        <Col xs={24} sm={24} md={7} lg={7} xl={7}>

                                            <FormItem
                                                style={{ marginBottom: '0px' }}
                                            >
                                                {getFieldDecorator('councilGuid', {
                                                    // initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
                                                    rules: [{ required: true, message: 'Select Your Council Name or Location!' }],
                                                })(
                                                    <Select
                                                        showAction={['focus', 'click']}
                                                        showSearch
                                                        style={{ width: '100%' }}
                                                        placeholder="Select Your Council Name or Location!"
                                                        optionFilterProp="children"
                                                        // onChange={(e) => {
                                                        //     this.setState({
                                                        //         scoutsCountry: e,
                                                        //     })
                                                        // }}
                                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    >
                                                        {this.allCouncils()}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col xs={24} sm={24} md={7} lg={7} xl={7}>

                                            <FormItem hasFeedback
                                                style={{ marginBottom: '0px' }}
                                            >
                                                {getFieldDecorator('memberid', {
                                                    // initialValue: eagleInfo.memberId ? eagleInfo.memberId : '',
                                                    rules: [{ required: true, min: 2, message: 'Enter Your MemberID!' },
                                                    {
                                                        pattern: new RegExp("^[0-9]*$"),
                                                        message:
                                                            "MemberID must be numeric!",
                                                    }],
                                                })(
                                                    <Input placeholder="Member ID" />
                                                )}
                                            </FormItem>
                                        </Col>

                                        <Col className='xs-center sm-center' xs={12} sm={12} md={7} lg={7} xl={7}>
                                            <div className='step-container' >
                                                <Button type="primary" className='submit-btn' loading={this.props.isAddingMID} style={{ margin: 0, height: '56px', width: "100%" }} htmlType='submit'>{this.props.isAddingMID ? 'ADDING MEMBER ID' : 'ADD MEMBER ID'}</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                                {/* </Row> */}
                            </div>
                            {this.props.loading || this.props.updating || this.props.isAddingMID
                                ? <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Member ID..." />
                                :
                                <Row type="flex" justify='start' className='MID-section'
                                // justify="start" align="stretch"
                                >
                                    {this.renderPrimaryMemberid()}
                                    {this.renderMemberid()}
                                </Row>
                            }
                        </div>
                    </Col>
                </Row>

                {this.props.loading || this.props.updating || this.props.isAddingMID
                    ? null
                    : <MyAwardsComponent
                        // ManageMemberIDPage={false}
                        // memberIDs={this.props.memberids}
                    />
                }
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        loading: state.getmemberidreducer.loading,
        isAddingMID: state.getmemberidreducer.isAddingMID,
        memberids: state.getmemberidreducer.memberids,
        updating: state.updatememberidreducer.loading,
        allCouncils: state.orgCouncilsReducer.councils,
        profileinfo: state.profilereducer.profileinfo,
        profileloading: state.profilereducer.loading,
        isadmin: state.isadminreducer.isadmin,
        eagleInfo: state.eagleinforeducer.eagleinfo,
        ranks_loading: state.myranksreducer.loading,
        ranks: state.myranksreducer.ranks,
        allranks_loading: state.allranksreducer.loading,
        allranks: state.allranksreducer.ranks,
        pic_updating: state.profilepicturereducer.loading,
        pic_updated: state.profilepicturereducer.status,
        privacy_updating: state.privacysettingsreducer.loading,
        awardsloading: state.awardsreducer.loading,
        awards: state.awardsreducer.awards,
        affinities_loading: state.affinitiesreducer.loading,
        affinities: state.affinitiesreducer.affinities,
        localAwards_Loading: state.localAwardsReducer.loading,
        localAwards: state.localAwardsReducer.localAwards,
        scoutings_loading: state.scoutingsreducer.loading,
        scoutings: state.scoutingsreducer.scoutings,
        scoutings_deleting: state.scoutingsdeletereducer.loading,
        scoutings_adding: state.scoutingsaddreducer.loading,
        councils: state.councilsreducer.councils,
        councils_adding: state.councilsaddreducer.loading,
        councils_deleting: state.councildeletereducer.loading,
        nesa_loading: state.nesaregistrationreducer.loading,
        nesa_reg: state.nesaregistrationreducer.reg,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        isspecialist: state.isadminreducer.isspecialist,
        searching: state.eagleSearchReducer.searching,
        searchedEagle: state.eagleSearchReducer.eagle,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(ManageMemberID));


// WEBPACK FOOTER //
// ./src/components/Inc/ManageMemberID.js